import { h, toast } from '../dom';
import { api, type User } from '../../api/client';
import { avatar, confirmBox, guard, pickFriends, section } from '../components';
import { shell } from '../shell';
import { navigate, queryParam } from '../router';
import { shareInvite } from '../share';

export async function inviteFriendsTo(roomId: string, memberIds: string[]) {
  const friends = await guard(api.friends());
  if (!friends) return;
  const ids = await pickFriends(friends, 'Mời bạn vào phòng', 'Gửi lời mời', memberIds);
  if (ids.length) await guard(api.invite(roomId, ids), `Đã mời ${ids.length} người ♡`);
}

export function renderRoom(root: HTMLElement, me: User, id: string) {
  const content = shell(root, { title: 'Phòng', back: '#/rooms' });
  content.append(section(() => api.room(id), (room, reload) => {
    const memberIds = room.members.map((m) => m.user.id);
    if (queryParam('invite') === '1') {
      history.replaceState(null, '', `#/room/${id}`);
      setTimeout(() => void inviteFriendsTo(room.id, memberIds).then(reload), 50);
    }
    return h('div', {},
      h('section.card.roomhead', {},
        h('div.bigicon', {}, room.kind === 'PERSISTENT' ? '🏡' : '⚡'),
        h('h2', {}, room.title || 'Phòng chụp'),
        h('button.code', { onclick: () => shareInvite(room.code).then(() => toast('Đã copy/chia sẻ mã phòng')) },
          h('small', {}, 'Mã phòng · chạm để chia sẻ'), h('b', {}, room.code)),
        h('div.row.wrap', {},
          h('a.primary.btn', { href: `#/booth/${room.id}` }, '📸 Vào chụp'),
          h('button.secondary', { onclick: () => void inviteFriendsTo(room.id, memberIds).then(reload) }, '+ Mời bạn'))),
      h('h3', {}, `Thành viên (${room.members.length})`),
      h('div.ulist', {}, ...room.members.map((m) => h('a.urow', { href: `#/u/${m.user.id}` },
        avatar(m.user, 40), h('div.umain', {}, h('b', {}, m.user.displayName), h('small', {}, m.role === 'OWNER' ? 'Chủ phòng' : 'Thành viên'))))),
      h('button.link.danger', {
        onclick: async () => {
          if (!(await confirmBox(room.owner.id === me.id ? 'Rời phòng? Quyền chủ phòng sẽ chuyển cho người khác.' : 'Rời phòng này?', 'Rời phòng'))) return;
          await guard(api.leaveRoom(room.id));
          navigate('#/rooms');
        },
      }, 'Rời phòng'));
  }));
}
